// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__9Mr2G","paymentContainer":"PaymentPage_paymentContainer__3WfGU"};